import { Link } from "react-router-dom-7"

import { MaterialIcon, PopupHint } from "~/shared/ui"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"
import { actionButtonSize } from "~/templates/main/MainUserbar/style"

export function ProfileButton({ username }) {

	const showUsername = useMediaQuery({ minWidth: breakPoints.md })
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	return (
		<PopupHint text="Профиль" position="bottom">
			<Link
				to="/main/profile"
				className="flex items-center justify-center gap-[0.5rem]"
				style={{ textDecoration: "none" }}
			>
				<MaterialIcon
					style={{
						flex: "0 1 auto",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						fontSize: isSmallDevice ? "1.6rem" : "2.2rem",
						color: "var(--cs-primary-dark)",
						...actionButtonSize
					}}
					name="account_circle"
				/>
				{showUsername && <span className="text-center">{username}</span>}
			</Link>
		</PopupHint>
	)
}
